export enum ResourceType {
  MEDICAL_KIT = 'MEDICAL KIT',
  MEDICINE = 'MEDICINE',
  OXYGEN = 'OXYGEN',
  BLOOD = 'BLOOD'
}
